import { useEffect, useState } from 'react';
import { TailSpin } from 'react-loader-spinner';
import { Grid } from '@mui/material';

// hooks
import GetQueryParam from './hooks/getQuery';

// components
import { useCustomContext } from './components/ContextHook';
import Footer from './components/Footer';
import RequireAuth from './components/RequiredAuth';
import ResponseLoggedIn from './components/ResponseLoggedIn';
import { useTheme } from './hooks/ThemeContext';

// models
import User from './model/User'

// services
import Service from './service/MutualService';

// styles
import './App.scss';
import Card from './components/Card';


function App() {
  const action = GetQueryParam('action');
  const theme = useTheme()
  const { setIsLoggedContext, setWidthContext, setUserInstance, configs } = useCustomContext()
  const [loading, setLoading] = useState(false)
  const backgroundColorMain = configs?.currentEvent?.theme?.reStyled.backgroundColor || '#000080'

  useEffect(() => {
    const updateDimensions = () => {
      const width = window.innerWidth;
      setWidthContext(width);
    }

    window.addEventListener("resize", updateDimensions);
    updateDimensions();
    return () => window.removeEventListener("resize", updateDimensions)
  }, [setWidthContext])


  //Here we analyze if the user has a cookie.
  useEffect(() => {
    const getUserInstance = async () => {
      const response = await Service.getUserInstance()
      if (response.success) {
        setIsLoggedContext(true)
        setUserInstance(new User(response.mutualID, response.firstName, response.lastName, true, response.photo, response.premium));
      }
      else {
        setIsLoggedContext(false)
      }
      setLoading(false)
    }

    getUserInstance()
  }, [setIsLoggedContext, setUserInstance])

  if (action === 'success' || action === 'cancel') {
    if (loading) {
      return (
        <Grid container flexDirection='column' justifyContent='center' alignItems='center' style={{ height: '80vh' }}>
          <TailSpin
            height="100"
            width="100"
            color='#FF3363'
            ariaLabel='loading'
          />
        </Grid>
      )
    }
    else {
      return (
        <section className='container'>
          <main>
            <RequireAuth>
              <ResponseLoggedIn />
            </RequireAuth>
          </main>
        </section>
      )
    }
  }

  else {
    return configs ? (
      <section className='container'>

        <main style={{ backgroundColor: backgroundColorMain }}>
          <Card products={theme.products} />
        </main>

        <Grid item xs={12} className='footer-grid'>
          <Footer />
        </Grid>
      </section>
    )
      : null;
  }
}

export default App;
